import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_main.routes';

export class OemMainController {
    /*@ngInject*/
    constructor($auth) {
        this.logout = () => { $auth.signOut(); };
    }

    $onInit() {
    }
}

export default angular.module('leptonApp.oemMain', [uiRouter])
    .config(routing)
    .component('oemMain', {
        template: require('./oem_main.html'),
        controller: OemMainController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem_main/oem_main.component.js